import { Component } from '@angular/core';

import { BaseChartComponent } from './base-chart/base-chart.component';

@Component({
  selector: 'cam-bar-chart',
  templateUrl: './base-chart/base-chart.component.html',
  styleUrls: ['./base-chart/base-chart.component.scss'],
})
export class CamChartBarComponent extends BaseChartComponent<'bar'> {
  constructor() {
    super();

    this.type = 'bar';
  }
}
